import { useState } from 'react';
import { api, ApiError } from '@tvx/api-client';

/**
 * Sign in.
 *
 * There is no sign-up and no password reset: console accounts are made by an
 * Owner under Settings → Team, and a forgotten one is reset there too. Saying
 * that here is kinder than a "forgot password?" link that goes nowhere.
 */
export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [shown, setShown] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post('/auth/login', { email: email.trim(), password });
      onSignedIn();
    } catch (err) {
      /* The server says "wrong email or password" without saying which, and
         this does not improve on that: which half was wrong is exactly what
         somebody guessing wants to know. */
      setError(err instanceof ApiError ? err.message : 'Could not sign in. Try again.');
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <form className="crd" onSubmit={submit} style={{ width: '100%', maxWidth: 380, padding: '34px 32px' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src="/assets/tradevix-mark.png" alt="" style={{ width: 44, height: 44, borderRadius: 12 }} />
          <div style={{ fontSize: 9.5, letterSpacing: '.16em', textTransform: 'uppercase',
            color: 'var(--tx3)', marginTop: 12 }}>Tradevix admin</div>
          <h1 style={{ fontSize: 26, marginTop: 6 }}>Sign in</h1>
          <p style={{ fontSize: 12.5, color: 'var(--tx3)', marginTop: 8, lineHeight: 1.5 }}>
            This console manages published content. Accounts are created by an Owner.
          </p>
        </div>

        {error ? <div className="err">{error}</div> : null}

        <div className="fld">
          <label className="lbl" htmlFor="email">Email</label>
          <input className="inp" id="email" type="email" autoComplete="username" autoFocus
            value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@tradevix.in" />
        </div>

        <div className="fld">
          <label className="lbl" htmlFor="password">Password</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input className="inp" id="password" type={shown ? 'text' : 'password'} autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)} />
            <button className="b bo" type="button" style={{ padding: '9px 14px', fontSize: 12 }}
              onClick={() => setShown((v) => !v)}>{shown ? 'Hide' : 'Show'}</button>
          </div>
        </div>

        <button className="b bg" type="submit" disabled={busy || !email || !password}
          style={{ width: '100%', marginTop: 8, justifyContent: 'center' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="hint" style={{ textAlign: 'center', marginTop: 16 }}>
          Locked out? An Owner can set a new password for you under Settings → Team.
        </p>
      </form>
    </div>
  );
}
